import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-instituicao',
  templateUrl: './card-instituicao.component.html',
  styleUrls: ['./card-instituicao.component.scss']
})
export class CardInstituicaoComponent implements OnInit {
  @Input() titulo: string;
  @Input() nome: string; // ok
  @Input() endereco = ''; // ok
  @Input() telefone: string; // ok
  @Input() email: string;
  @Input() tipo: string;
  @Input() homePage: string;

  cursoMsg: string = null; // ok
  cardTipo: string;
  encurtarTexto = true; // ok
  bgColor: string;
  displayMoreBtn: boolean;
  constructor() { }

  ngOnInit(): void {
  }

  displayBtn(text: string): boolean {
    const textLength = text.replace(/\<.*?\>(.*?)\<\/.*?\>/gi, '$1').length;
    return textLength > 144 ? true : false;
  }

  routerLink(lnk: any) {
    return lnk;
  }

  // marcarTexto(texto: string, termo: string): string {
  //   if (!termo) return texto;
  //   const regex = new RegExp(`(${termo})`, 'gi');
  //   return texto.replace(regex, '<span class="highlight">$1</span>');
  // }
}
